import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ILanguage } from '@interfaces/language';
import { Store } from '@ngxs/store';
import { AuthenticationService } from '@services/authentication.service';
import { GetLanguages } from '@store/languages.action';
import { LanguagesState } from '@store/languages.state';
import { ChangeLanguageSetting } from '@store/profiles.action';
import { ProfilesState } from '@store/profiles.state';
import { Observable, Subscription, take } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-language-selector',
    templateUrl: './language-selector.component.html',
    imports: [AsyncPipe, TranslatePipe]
})
export class LanguageSelectorComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  private store = inject(Store);
  private authenticationService = inject(AuthenticationService);

  public selectedLanguage$: Observable<string | undefined> = this.store.select(ProfilesState.getSelectedLanguage);
  public languages$: Observable<ILanguage[] | undefined> = this.store.select(LanguagesState.getLanguages);

  public ngOnInit(): void {
    // Load languages initially if not present
    this.loadLanguagesIfNeeded();

    // Subscribe to languages state changes to reload when state is reset (e.g., after logout)
    this.subscriptions.push(
      this.store.select(LanguagesState.getLanguages)
        .pipe(filter(languages => languages === undefined))
        .subscribe(() => {
          this.loadLanguagesIfNeeded();
        })
    );
  }

  private loadLanguagesIfNeeded(): void {
    this.languages$.pipe(take(1)).subscribe((languages) => {
      if (!languages) {
        this.store.dispatch(new GetLanguages());
      }
    });
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach(x => x.unsubscribe());
  }

  public changeLanguage(code: string): void {
    this.subscriptions.push(
      this.authenticationService.isAuthorized().subscribe(authenticated => {
        this.store.dispatch(new ChangeLanguageSetting(code, authenticated));
      })
    );
  }
}
